import { render, staticRenderFns } from "./privateWallet.vue?vue&type=template&id=7ff75930&scoped=true"
import script from "./privateWallet.vue?vue&type=script&lang=js"
export * from "./privateWallet.vue?vue&type=script&lang=js"
import style0 from "./privateWallet.vue?vue&type=style&index=0&id=7ff75930&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.104.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff75930",
  null
  
)

export default component.exports